// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__3nTJI","active":"NavigationItem_active__3XGbF"};